<template>
  <div class="product-review">
    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">商品名称：</span>
            <el-input v-model="searchInfo.name" clearable placeholder="请输入商品名称"></el-input>
          </div>
          <div class="search-item">
            <span class="label">商品状态：</span>
            <el-select v-model="searchInfo.status" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in statusList" :key="i" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">商品分类：</span>
            <el-select v-model="searchInfo.categoryId" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in categoryList" :key="i" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">关键词：</span>
            <el-input v-model="searchInfo.keyword" clearable placeholder="请输入关键词"></el-input>
          </div>
          <div class="search-item date-picker">
            <span class="label">创建时间：</span>
            <el-date-picker v-model="searchDateArr" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-plus" @click="showAddDialog" v-if="$can('product:add')">新增商品</el-button>
      </div>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" max-height="600px" @row-dblclick="handleRowDblClick">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="mainImage" label="商品图片" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.mainImage"
              :src="scope.row.mainImage"
              :preview-src-list="[scope.row.mainImage]"
              style="width: 60px; height: 60px; border-radius: 4px;"
              fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="categoryName" label="商品分类" width="120"></el-table-column>
        <el-table-column prop="price" label="售价" width="100">
          <template slot-scope="scope">
            <span style="color: #E6A23C; font-weight: 500;">¥{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="originalPrice" label="原价" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.originalPrice" style="text-decoration: line-through; color: #999;">¥{{ scope.row.originalPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="stock" label="库存" width="80">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.stock <= 10 ? '#F56C6C' : '#67C23A' }">{{ scope.row.stock }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="$can('product:view')" @click="viewDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small" v-if="$can('product:edit')" @click="editProduct(scope.row)">编辑</el-button>
            <el-button
              type="text"
              size="small"
              v-if="$can('product:edit')"
              @click="changeStatus(scope.row)"
              :style="{ color: scope.row.status === 1 ? '#F56C6C' : '#67C23A' }"
            >
              {{ scope.row.status === 1 ? '下架' : '上架' }}
            </el-button>
            <el-button type="text" size="small" v-if="$can('product:delete')" @click="confirmDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>

    <!-- 商品详情弹窗 -->
    <el-dialog
      title="商品详情"
      :visible.sync="productDetailVisible"
      width="900px"
      :before-close="handleClose">
      <div v-if="productDetail">
        <div class="product-detail">
          <div class="product-preview">
            <div class="product-images">
              <el-image
                v-if="productDetail.mainImage"
                :src="productDetail.mainImage"
                style="width: 200px; height: 200px; border-radius: 8px;"
                fit="cover"
              />
              <div class="image-gallery" v-if="productDetail.images && productDetail.images.length">
                <el-image
                  v-for="(img, index) in productDetail.images.slice(0, 4)"
                  :key="index"
                  :src="img"
                  :preview-src-list="productDetail.images"
                  style="width: 80px; height: 80px; border-radius: 4px; margin: 5px;"
                  fit="cover"
                />
              </div>
            </div>
            <div class="product-info">
              <h3>{{ productDetail.name }}</h3>
              <p class="description">{{ productDetail.description }}</p>
              <div class="price-info">
                <span class="current-price">¥{{ productDetail.price }}</span>
                <span v-if="productDetail.originalPrice" class="original-price">¥{{ productDetail.originalPrice }}</span>
              </div>
              <div class="meta-info">
                <el-tag>{{ productDetail.categoryName }}</el-tag>
                <span class="stock">库存: {{ productDetail.stock }}</span>
              </div>
            </div>
          </div>

          <el-form label-width="100px" class="detail-form">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="商品分类:">{{ productDetail.categoryName }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品状态:">
                  <el-tag :type="getStatusTagType(productDetail.status)">
                    {{ getStatusText(productDetail.status) }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="售价:">¥{{ productDetail.price }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="原价:">
                  <span v-if="productDetail.originalPrice">¥{{ productDetail.originalPrice }}</span>
                  <span v-else>--</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="库存数量:">{{ productDetail.stock }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="创建时间:">{{ productDetail.createTime }}</el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="productDetail.specifications">
              <el-col :span="24">
                <el-form-item label="商品规格:">
                  <div class="specifications">
                    <el-tag
                      v-for="(value, key) in productDetail.specifications"
                      :key="key"
                      style="margin: 2px 5px 2px 0;"
                    >
                      {{ key }}: {{ value }}
                    </el-tag>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!-- 商品编辑/新增弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="productDialogVisible"
      width="800px"
      :before-close="handleFormClose">
      <el-form :model="productForm" :rules="formRules" ref="productForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商品名称" prop="name">
              <el-input v-model="productForm.name" placeholder="请输入商品名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品分类" prop="categoryId">
              <el-select v-model="productForm.categoryId" placeholder="请选择商品分类" style="width: 100%;">
                <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="售价" prop="price">
              <el-input-number v-model="productForm.price" :precision="2" :min="0" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原价">
              <el-input-number v-model="productForm.originalPrice" :precision="2" :min="0" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="库存数量" prop="stock">
              <el-input-number v-model="productForm.stock" :min="0" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品状态">
              <el-select v-model="productForm.status" style="width: 100%;">
                <el-option label="下架" :value="0"></el-option>
                <el-option label="上架" :value="1"></el-option>
                <el-option label="审核中" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品描述">
          <el-input v-model="productForm.description" type="textarea" :rows="3" placeholder="请输入商品描述"></el-input>
        </el-form-item>
        <el-form-item label="商品主图">
          <el-input v-model="productForm.mainImage" placeholder="请输入商品主图URL"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="productDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitProduct" :loading="saving">保存</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  export default {
    name: "product-review",
    data () {
      return {
        // 表格数据
        total: 0,
        tableData: [],
        searchDateArr: [],
        loading: false,
        currentPage: 1,
        saving: false,
        // 弹窗控制
        productDetailVisible: false,
        productDialogVisible: false,
        productDetail: null,
        dialogTitle: '新增商品',
        isEdit: false,
        // 商品表单
        productForm: {
          id: null,
          name: '',
          description: '',
          price: null,
          originalPrice: null,
          stock: 0,
          categoryId: '',
          mainImage: '',
          status: 1
        },
        // 搜索条件
        searchInfo: {
          name: '',
          status: '',
          categoryId: '',
          keyword: '',
          startDate: '',
          endDate: '',
          pageNumber: 1,
          pageSize: 20,
        },
        // 下拉列表数据
        statusList: [
          { label: '下架', value: 0 },
          { label: '上架', value: 1 },
          { label: '审核中', value: 2 },
          { label: '已删除', value: 3 }
        ],
        categoryList: [],
        // 表单验证规则
        formRules: {
          name: [
            { required: true, message: '请输入商品名称', trigger: 'blur' }
          ],
          categoryId: [
            { required: true, message: '请选择商品分类', trigger: 'change' }
          ],
          price: [
            { required: true, message: '请输入商品价格', trigger: 'blur' }
          ],
          stock: [
            { required: true, message: '请输入库存数量', trigger: 'blur' }
          ]
        },
        // 日期选择器配置
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    watch: {
      'searchInfo.name'(newVal){
        if (newVal === ""){
          this.getProductList();
        }
      },
      'searchInfo.keyword'(newVal){
        if (newVal === ""){
          this.getProductList();
        }
      },
      'searchDateArr'(newVal){
        if (newVal === null){
          this.searchInfo.startDate = "";
          this.searchInfo.endDate = "";
          this.getProductList();
        }
      },
    },
    created() {
      this.getProductList();
      this.getCategoryList();
    },
    methods: {
      // 搜索
      search() {
        this.currentPage = 1;
        this.searchInfo.pageNumber = 1;
        this.getProductList();
      },

      // 分页处理
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val;
        this.getProductList();
      },

      handleSizeChange(val) {
        this.currentPage = 1;
        this.searchInfo.pageSize = val;
        this.searchInfo.pageNumber = 1;
        this.getProductList();
      },

      // 获取商品列表
      getProductList() {
        if (this.searchDateArr && this.searchDateArr.length === 2) {
          this.searchInfo.startDate = this.searchDateArr[0];
          this.searchInfo.endDate = this.searchDateArr[1];
        }

        if (this.loading) return;
        this.loading = true;

        axios.get('/admin/product/list', {
          params: this.searchInfo
        }).then(result => {
          this.loading = false;
          if (result.code === 200) {
            this.total = result.data.total;
            this.tableData = result.data.list;
          } else {
            this.$message.error(result.message || '获取数据失败');
          }
        }).catch(err => {
          console.error(err);
          this.loading = false;
          this.$message.error('网络异常，请重试');
        });
      },

      // 获取分类列表
      getCategoryList() {
        axios.get('/admin/category/list').then(result => {
          if (result.code === 200) {
            this.categoryList = result.data;
          }
        }).catch(err => {
          console.error('获取分类列表失败:', err);
        });
      },

      // 查看商品详情
      viewDetail(row) {
        this.getProductDetail(row.id);
      },

      // 获取商品详情
      getProductDetail(id) {
        axios.get(`/admin/product/${id}`).then(result => {
          if (result.code === 200) {
            this.productDetail = result.data;
            this.productDetailVisible = true;
          } else {
            this.$message.error('获取商品详情失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 显示新增对话框
      showAddDialog() {
        this.dialogTitle = '新增商品';
        this.isEdit = false;
        this.resetForm();
        this.productDialogVisible = true;
      },

      // 编辑商品
      editProduct(row) {
        this.dialogTitle = '编辑商品';
        this.isEdit = true;
        this.productForm = {
          id: row.id,
          name: row.name,
          description: row.description || '',
          price: row.price,
          originalPrice: row.originalPrice,
          stock: row.stock,
          categoryId: row.categoryId,
          mainImage: row.mainImage || '',
          status: row.status
        };
        this.productDialogVisible = true;
      },

      // 保存商品
      submitProduct() {
        this.$refs.productForm.validate((valid) => {
          if (valid) {
            this.saving = true;
            const url = this.isEdit ? `/admin/product/${this.productForm.id}` : '/admin/product';
            const method = this.isEdit ? 'put' : 'post';

            axios[method](url, this.productForm).then(result => {
              this.saving = false;
              if (result.code === 200) {
                this.$message.success(this.isEdit ? '更新成功' : '添加成功');
                this.productDialogVisible = false;
                this.getProductList();
              } else {
                this.$message.error(result.message || '操作失败');
              }
            }).catch(err => {
              console.error(err);
              this.saving = false;
              this.$message.error('网络异常，请重试');
            });
          }
        });
      },

      // 更改商品状态
      changeStatus(row) {
        const newStatus = row.status === 1 ? 0 : 1;
        const operation = newStatus === 1 ? '上架' : '下架';

        this.$confirm(`确定要${operation}商品"${row.name}"吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.put(`/admin/product/${row.id}/status`, {
            status: newStatus
          }).then(result => {
            if (result.code === 200) {
              this.$message.success(`${operation}成功`);
              this.getProductList();
            } else {
              this.$message.error(result.message || `${operation}失败`);
            }
          }).catch(err => {
            console.error(err);
            this.$message.error('网络异常，请重试');
          });
        }).catch(() => {
          this.$message.info(`已取消${operation}`);
        });
      },

      // 删除商品
      confirmDelete(row) {
        this.$confirm(`确定要删除商品"${row.name}"吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteProduct(row.id);
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      },

      deleteProduct(id) {
        axios.delete(`/admin/product/${id}`).then(result => {
          if (result.code === 200) {
            this.$message.success('删除成功');
            this.getProductList();
          } else {
            this.$message.error(result.message || '删除失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 双击行事件
      handleRowDblClick(row) {
        this.viewDetail(row);
      },

      // 关闭弹窗
      handleClose(done) {
        this.productDetail = null;
        done();
      },

      handleFormClose(done) {
        this.resetForm();
        done();
      },

      // 重置表单
      resetForm() {
        this.productForm = {
          id: null,
          name: '',
          description: '',
          price: null,
          originalPrice: null,
          stock: 0,
          categoryId: '',
          mainImage: '',
          status: 1
        };
        if (this.$refs.productForm) {
          this.$refs.productForm.clearValidate();
        }
      },

      // 工具方法
      getStatusText(status) {
        const statusMap = {
          0: '下架',
          1: '上架',
          2: '审核中',
          3: '已删除'
        };
        return statusMap[status] || '未知';
      },

      getStatusTagType(status) {
        const typeMap = {
          0: 'info',
          1: 'success',
          2: 'warning',
          3: 'danger'
        };
        return typeMap[status] || 'info';
      }
    }
  }
</script>
<style lang="less" scoped>
  .product-review {
    .product-detail {
      .product-preview {
        display: flex;
        margin-bottom: 20px;

        .product-images {
          margin-right: 20px;

          .image-gallery {
            margin-top: 10px;
            display: flex;
            flex-wrap: wrap;
          }
        }

        .product-info {
          flex: 1;

          h3 {
            margin: 0 0 10px 0;
            color: #333;
            font-size: 18px;
          }

          .description {
            color: #666;
            line-height: 1.5;
            margin-bottom: 15px;
          }

          .price-info {
            margin-bottom: 15px;

            .current-price {
              color: #E6A23C;
              font-size: 24px;
              font-weight: bold;
              margin-right: 10px;
            }

            .original-price {
              color: #999;
              font-size: 16px;
              text-decoration: line-through;
            }
          }

          .meta-info {
            display: flex;
            align-items: center;
            gap: 15px;

            .stock {
              color: #999;
              font-size: 14px;
            }
          }
        }
      }

      .detail-form {
        .el-form-item {
          margin-bottom: 12px;
        }
      }

      .specifications {
        .el-tag {
          margin: 2px 5px 2px 0;
        }
      }
    }
  }

  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          &.date-picker {
            .el-date-editor {
              width: 280px !important;
              /deep/ .el-input__inner {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .search-btn {
      padding-top: 0;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
        margin-left: 8px;
      }
    }
  }

  .tableStyle {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }

    .product-detail {
      .product-preview {
        flex-direction: column;

        .product-images {
          margin-right: 0;
          margin-bottom: 15px;
        }
      }
    }
  }

  /deep/ .el-date-editor .el-range-separator {
    color: #606266 !important;
  }

  /deep/ .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
  }

  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  /deep/ .el-table .warning-row {
    background: #fdf6ec;
  }

  /deep/ .el-table .danger-row {
    background: #fef0f0;
  }
</style>
